
import { Component, Vue } from "vue-property-decorator";
import { Store } from "vuex";
import { IUserProfile } from "@/interfaces";
import { readAdminUsers } from "@/store/admin/getters";
import {
  dispatchExportAllUsers,
  dispatchGetUsers,
} from "@/store/admin/actions";

@Component
export default class AdminUsers extends Vue {
  public headers = [
    {
      text: "Nickname",
      sortable: true,
      value: "nickname",
      align: "left",
    },
    {
      text: "Email",
      sortable: true,
      value: "email",
      align: "left",
    },
    {
      text: "Is Active",
      sortable: true,
      value: "isActive",
      align: "left",
    },
    {
      text: "Is Superuser",
      sortable: true,
      value: "isSuperuser",
      align: "left",
    },
    {
      text: "Actions",
      value: "id",
    },
  ];
  get users() {
    return readAdminUsers(this.$store);
  }

  public async mounted() {
    await dispatchGetUsers(this.$store);
  }

  public async exportButtonClicked() {
    await dispatchExportAllUsers(this.$store);
  }
}
